import { createContext } from 'react';

import type { PersonalBeautyStoreContext } from '../../types';

export const personalBeautyStoreContext = createContext<PersonalBeautyStoreContext>({
  pbsData: null,
  inviteFriendData: null,
  storeInfo: null,
  canDisplaySponsorInfo: false,
  canDisplayTooltip: false,
  tooltipWasShown: false,
  setTooltipWasShown: () => {},
});
